import Resume from './components/resume';

export { default as initializePdf } from './initialize_pdf';

const ResumeViewer = Resume;
export default ResumeViewer;
